import {
  Box,
  Button,
  ButtonGroup,
  Checkbox,
  Flex,
  FormControl,
} from "@chakra-ui/react";
import {
  CollecticonArrowSpinCcw,
  CollecticonXmarkSmall,
} from "@devseed-ui/collecticons-chakra";
import { useInferenceFiltersContext } from "../context/InferenceFiltersContext";

import Slider from "./Slider";

function InferenceFilters() {
  const {
    isWhale,
    setIsWhale,
    isValid,
    setIsValid,
    inferencesValidated,
    setInferencesValidated,
    minConfidence,
    setMinConfidence,
    minCoastlineDistance,
    setMinCoastlineDistance,
    isFlagged,
    setIsFlagged,
    resetFilters,
  } = useInferenceFiltersContext();

  return (
    <FormControl display="flex" flexDir="column" gap="2">
      <Box>
        <Checkbox
          isChecked={!isWhale}
          colorScheme="primary"
          fontWeight="semibold"
          onChange={(e) => setIsWhale(!e.target.checked || undefined)} // if checked, isWhale should be undefined
          sx={{ "& > span": { fontSize: "sm" } }}
        >
          Show non-whale detections
        </Checkbox>
      </Box>
      <Box>
        <Checkbox
          isChecked={isFlagged === true}
          colorScheme="orange"
          fontWeight="semibold"
          onChange={(e) => setIsFlagged(e.target.checked || undefined)} // if checked, isFlagged should be true
          sx={{ "& > span": { fontSize: "sm" } }}
        >
          Show flagged detections only
        </Checkbox>
      </Box>
      <Box>
        <Box
          fontWeight="semibold"
          fontSize="sm"
          id="min_confidence"
          display="flex"
          alignItems="center"
          gap="2"
        >
          Confidence Threshold
        </Box>
        <Slider
          labelId="min_confidence"
          step={0.05}
          minValue={0.1}
          maxValue={1}
          value={minConfidence}
          onChange={(value: number) => setMinConfidence(value)}
        />
      </Box>
      <Box>
        <Box fontWeight="semibold" fontSize="sm" id="min_coastline_distance">
          Minimum Distance to Coastline (m)
        </Box>
        <Slider
          labelId="min_coastline_distance"
          step={5}
          minValue={40}
          maxValue={1000}
          value={minCoastlineDistance}
          onChange={(value: number) => setMinCoastlineDistance(value)}
        />
      </Box>
      <Box
        fontWeight="semibold"
        fontSize="sm"
        id="min_coastline_distance"
        gap="2"
        display="flex"
        flexDir="column"
      >
        Validation
        <ButtonGroup variant="outline" isAttached size="sm" width="100%">
          <Button
            onClick={() => {
              setIsValid(isValid ? undefined : true);
              setInferencesValidated(undefined);
            }}
            isActive={isValid === true}
            flex="1"
          >
            Valid
          </Button>
          <Button
            onClick={() => {
              setIsValid(isValid === false ? undefined : false);
              setInferencesValidated(undefined);
            }}
            isActive={isValid === false}
            flex="1"
          >
            Invalid
          </Button>
          <Button
            onClick={() => {
              setInferencesValidated(
                inferencesValidated === false ? undefined : false,
              );
              setIsValid(undefined);
            }}
            isActive={inferencesValidated === false}
            flex="1"
          >
            Not Validated
          </Button>
        </ButtonGroup>
      </Box>
      <Flex mt="2" justifyContent="space-between">
        <Button
          variant="solid"
          colorScheme="primary"
          size="xs"
          alignSelf="start"
          rightIcon={<CollecticonArrowSpinCcw size="10px" />}
          onClick={resetFilters}
        >
          Reset Defaults
        </Button>
        <Button
          variant="ghost"
          colorScheme="primary"
          size="xs"
          alignSelf="start"
          rightIcon={<CollecticonXmarkSmall size="10px" />}
          isDisabled={
            isValid === undefined &&
            inferencesValidated === undefined &&
            isWhale === undefined &&
            minConfidence === 0.1 &&
            minCoastlineDistance === 40 &&
            isFlagged === undefined
          }
          onClick={() => {
            setIsValid(undefined);
            setInferencesValidated(undefined);
            setIsWhale(undefined);
            setMinConfidence(0.1);
            setMinCoastlineDistance(40);
            setIsFlagged(undefined);
          }}
        >
          Remove Filters
        </Button>
      </Flex>
    </FormControl>
  );
}

export default InferenceFilters;
